exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-category-status a[data-v-47025e3d] {\n  text-decoration: none;\n  color: #212529;\n}\n.main-category-status .btn[data-v-47025e3d] {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 1rem;\n  border: 2px solid #252525;\n  border-radius: 3px;\n  font-weight: bold;\n  font-size: 1.2rem;\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n.main-category-status .counter[data-v-47025e3d] {\n  text-align: center;\n  font-weight: bold;\n  font-size: 1.2rem;\n}", ""]);

// exports
